import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth();

  const navigationItems = [
    { name: 'Inicio', path: '/', icon: 'Home' },
    { name: 'Evaluación', path: '/edad-real-assessment-quiz', icon: 'ClipboardList' },
    { name: 'Testimonios', path: '/testimonials', icon: 'Users' },
    { name: 'Blog', path: '/blog-content-hub', icon: 'BookOpen' },
    { name: 'Contacto', path: '/contact-lead-capture', icon: 'MessageCircle' }
  ];

  const isActivePath = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-card border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center" title="Come y Vive Sano - Inicio">
              <img
                src="/assets/images/logo_comeyvivesano.webp"
                alt="Come y Vive Sano - Coach de Hábitos Saludables"
                className="h-16 w-auto"
              />
              {/* SEO-friendly hidden text */}
              <h1 className="sr-only">Come y Vive Sano - Coach Platform</h1>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-6">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-body-semibold transition-smooth hover:bg-muted ${
                    isActivePath(item?.path)
                      ? 'text-primary bg-muted' :'text-foreground hover:text-primary'
                  } ${item?.name === 'Evaluación' ? 'text-accent hover:text-accent' : ''}`}
                >
                  <Icon name={item?.icon} size={16} />
                  <span>{item?.name}</span>
                </Link>
              ))}

              {/* Member Access Button - Only show when NOT logged in */}
              {!user && (
                <Link
                  to="/login"
                  className="flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-semibold bg-primary text-white hover:bg-primary/90 transition-smooth"
                >
                  <Icon name="LogIn" size={16} />
                  <span>Acceso Miembros</span>
                </Link>
              )}
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMobileMenu}
              className="md:hidden flex items-center justify-center w-12 h-12 rounded-md text-foreground hover:bg-muted transition-smooth"
              aria-label="Toggle mobile menu"
            >
              <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
            </button>
          </div>
        </div>
      </header>
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="fixed inset-0 bg-background/80 backdrop-blur-sm" onClick={closeMobileMenu} />
          <div className="fixed top-20 left-0 right-0 bg-card border-b border-border shadow-card-elevated">
            <nav className="px-4 py-6 space-y-4">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={closeMobileMenu}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg text-base font-body-semibold transition-smooth ${
                    isActivePath(item?.path)
                      ? 'text-primary bg-muted' :'text-foreground hover:bg-muted hover:text-primary'
                  } ${item?.name === 'Evaluación' ? 'bg-accent text-accent-foreground hover:bg-accent/90' : ''}`}
                >
                  <Icon name={item?.icon} size={20} />
                  <span>{item?.name}</span>
                </Link>
              ))}

              {/* Member Access Button for Mobile - Only show when NOT logged in */}
              {!user && (
                <Link
                  to="/login"
                  onClick={closeMobileMenu}
                  className="flex items-center space-x-3 px-4 py-3 rounded-lg text-base font-semibold bg-primary text-white hover:bg-primary/90 transition-smooth"
                >
                  <Icon name="LogIn" size={20} />
                  <span>Acceso Miembros</span>
                </Link>
              )}
            </nav>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;